import { makeStyles } from '@mui/styles';

const useStyles = makeStyles((theme) => ({
  checkbox: {
    width: '100%',
    marginTop: theme.spacing(3),
  },
}));

export default useStyles;
